module.exports = __webpack_public_path__ + "img/indicators_icon.283b5eed.png";